import { map } from "rxjs/operators";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as _ from "lodash";
import * as moment from "moment";
import { ModalViewreseauDeSoinDetailComponent } from "src/app/shared/components/modal-view-reseau-soin-detail/modal-view-reseau-soin-detail.component";
import { ModalViewGarantDetailsComponent } from "src/app/shared/components/modal-view-garant-details/modal-view-garant-details.component";


@Component({
  selector: 'app-bar-prime-statut',
  templateUrl: './bar-prime-statut.component.html',
  styleUrls: ['./bar-prime-statut.component.scss']
})
export class BarPrimeStatutComponent implements OnInit {

defaultValues: any = {};
  listItems: Array<any> = [];
  items: Array<any> = [];
  itemToSave: any = {};
  itemsStatutInitialized:any=[]
  filiale_id: any;
  @Output() onChangePrimeStatutForm = new EventEmitter<any>();
  @Output() onChangeModeTarification = new EventEmitter<any>();
  @Input() currentBareme: any;
  @Input() currentProduit: any;
  uniteFonctionnelleSelected: any = {};
  modalRef: BsModalRef;
  user: any = {};
  itemToSearch: any = {};
  currentPage: number = 0;
  itemsPerPage: number = 30;
  totalItems: number;
  show_password_field = true;
  busyGet: Subscription;
  busySave: Subscription;
  loading: boolean = false;
  endPoint: string = "produit";
  title: string = "produit";
  createMessage = "";
  editMessage = "";
  deleteMessage = "";
  itemsParentFonctionnalites = [];
  itemsModeTarification: any = [];
  itemsModeFractionnement: any = [];
  gender = "M";
  itemsRole: any;
  itemsSpecialites: any;
  itemsCivilite: any = [];
  itemsGenre: any = [];
  itemsFiliale: any = [];
  searchKey: any;
  dateNais: any;
  indiceTab: number = 0;
  bsValue: Date;
  imageName: string;
  imageDisplay: any;
  currentItemImage: {
    fileBase64: any;
    fileName: any;
    extension: any;
    typeDocument: string;
  };
  selectedUniteFoncId: any;
  selectedSpecialiteId: any;
  listSelectedUniteFonctionnelle = [];
  isAutoPassword = false;
  maxDate = new Date(
    new Date().getFullYear() - 18,
    new Date().getMonth() - 1,
    new Date().getDay()
  );
  minDate = new Date();
  itemsFucntParent: any[];
  itemsTypeGarant: any;
  itemsTypeAssurance: any[];
  itemsModeReconduction: any;
  isTarificationFamille: any;
  bsModalRefPreview: BsModalRef;
  itemsGarant: any;
  itemsGarantProduit: any[];
  currentFamilleGarantieBaremeStatut: any;
  itemsJourAutoriseToSave: any;
  itemToAdd: any = {};
  itemsPrimeByProduit: any = [];
  itemsStatut: any;
  currentData: any;
  itemsReseauDeSoin: any = [];
  is_tarif_famille: boolean;
  itemsGarantie: any;
  itemsChecked: any = [];
  itemsGarantieProduit: any = [];
  current_produit_id: any;
  itemsParamGlobal: any;
  itemsTypeRemboursement: any;
  itemToAddTrancheAge: any = {};
  itemsPrimeByStatutAndTrancheAge: any = [];
  itemsPrimeByTrancheAge: any = [];
  itemToAddStatutTrancheAge: any = {};
  itemsModeCalculPrime: any;
  currentModeCalculPrime: any;
  is_all_checked = false;
  itemsPrimeByProduitId: any;

  constructor(
    public bsModalRef: BsModalRef,
    private authService: AuthService,
    private restClient: RestClientService,
    private modalService: BsModalService,
    private utilities: UtilitiesService
  ) {
    // this.user = this.authService.currentUserValue;
    this.user = this.authService.getCurrentUser();
    // console.info('user-->: ',this.user)
    this.filiale_id = this.user.filiale_id;
    let text1 = this.gender == "M" ? "un" : "une";
    this.createMessage =
      "Vous êtes sur le point de créer " + text1 + " " + this.title;
    this.editMessage =
      "Vous êtes sur le point de modifier " + text1 + " " + this.title;
    this.itemToSave.plafond_annuel_famille = 0;
    this.itemToSave.prime_par_famille = 0;

    // this.itemToSave.mode_reconduction_id=''

    setTimeout(() => {
      console.log("here");
      // this.itemToSave.date_effet = new Date()
      // this.itemToSave.date_echeance = new Date((new Date()).getFullYear(), 11, 31, 23, 59, 59, 999);
      if (this.currentData) {
        console.log("currentData: ", this.currentData);

        this.itemToSave = Object.assign({}, this.currentData);
        this.current_produit_id = this.itemToSave.id;
        this.check_if_is_famille();
      }
    }, 50);
  }

  ngOnChanges(changes: SimpleChanges) {
    // debugger
    console.log("changes: ",changes)
    if (changes && changes.currentBareme && changes.currentBareme.currentValue && changes.currentProduit &&  changes.currentProduit.currentValue) {
      //si on est en mode modification de bareme
      this.itemToSave.mode_tarification_id = this.currentProduit.mode_tarification_id
      this.check_if_is_famille()
      if(changes.currentBareme.currentValue.id)
        this.getItemsProduitBaremeStatutConfig()
      else
        this.getItemsPlafondConfigStatut()
    }

  }

  refreshList(){
    if(this.currentBareme.id && this.currentProduit.id)
      this.getItemsProduitBaremeStatutConfig()
    else
      this.getItemsPlafondConfigStatut()
  }
  

  selectedChangeValue(event: any) {
    console.log("le event selectedChangeValue", event);

    if (!event) this.indiceTab = 0;

    this.indiceTab = event;
  }

  resetForm() {
    this.itemToSave.typeActeId = null;
    this.itemToSave.libelle = "";
    this.itemToAddTrancheAge.age_min = 0;
    if (this.itemsPrimeByTrancheAge && this.itemsPrimeByTrancheAge > 0) {
      this.itemToAddTrancheAge.age_min =
        Math.min(...this.itemsPrimeByTrancheAge.map((r) => r.age_max)) + 1;
    }

    this.itemToAddStatutTrancheAge.age_min = 0;
    if (
      this.itemsPrimeByStatutAndTrancheAge &&
      this.itemsPrimeByStatutAndTrancheAge > 0
    ) {
      this.itemToAddStatutTrancheAge.age_min =
        Math.min(
          ...this.itemsPrimeByStatutAndTrancheAge.map((r) => r.age_max)
        ) + 1;
    }
    // this.itemtad
  }

  

  hasPrimeNotFilled(): boolean {
    return this.itemsStatutInitialized.some(
      (isi) => isi.nombre_autorise > 0 && !isi.prime
    );
  }
  isAssurePrimeNotFilled(): boolean {
    return this.itemsStatutInitialized.some(
      (isi) => isi.codification == "A" && !isi.prime
    );
  }

  
  
  getItemsParametreSysteme() {
    // if(!this.current_produit_id){
    //   return
    // }
    let request = {
      user_id: this.user.id,
      filiale_id: this.filiale_id || this.user.filiale_id,
      data: {
        // produit_id: this.current_produit_id
      },
      index: 0,
      size: 10000,
    };

    this.busyGet = this.restClient
      .post("systemeGlobal/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"] && !res["hasError"]) {
            this.itemsParamGlobal = res["items"];
            console.log("itemsParamGlobal: ", this.itemsParamGlobal);
            // this.getItems()
            this.setDefautValues();
          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            this.itemsParamGlobal = [];
          }
        },
        (err) => {
          this.itemsParamGlobal = [];
        }
      );
  }

  
  findValueInGlobalParams(value) {
    let key = "codification";
    let to_return = "";
    console.log("this.itemsParamGlobal: ", this.itemsParamGlobal);
    if (this.itemsParamGlobal && this.itemsParamGlobal.length) {
      to_return = this.itemsParamGlobal.find(
        (item) => item[key] === value
      ).valeur;
    }
    console.log("to_return: ", to_return);
    return to_return;
  }

  getItemsGarant() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("garant/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsGarant = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsGarant = [];
          }
        },
        (err) => {
          this.itemsGarant = [];
        }
      );
  }
  

  
  

  getItemsModeTarification() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("modeTarification/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsModeTarification = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
            // if (!this.currentProduit.id) {
            //   this.set_default_mode_tarification("FAMILLE");
            // }
            this.check_if_is_famille();
          } else {
            this.itemsModeTarification = [];
          }
        },
        (err) => {
          this.itemsModeTarification = [];
        }
      );
  }

  
  

  isValidEmail(email) {
    // Regular expression for validating email addresses
    var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }

  generateUniqueString() {
    // Get current timestamp in milliseconds
    var timestamp = new Date().getTime();

    // Generate a random number
    var randomNumber = Math.floor(Math.random() * 1000000); // Adjust range as needed

    // Concatenate timestamp and random number
    var uniqueString = timestamp.toString() + randomNumber.toString();

    return uniqueString;
  }

  capitalize(str) {
    return str.replace(/^\w/, (c) => c.toUpperCase());
  }



  checkIfisTarificationFamille() {
    this.isTarificationFamille = false;
    if (this.itemsModeTarification && this.itemsModeTarification.length) {
      this.isTarificationFamille = !!this.itemsModeTarification.filter(
        (item) =>
          item.id == this.itemToSave.mode_tarification && item.code == "FAMILLE"
      ).length;
    }
    console.log("isTarificationFamille: ", this.isTarificationFamille);
  }

  generate_produit_pdf(item) {
    this.loading = true;
    var request = {
      user: this.user.id,
      data: { id: item.id },
    };
    this.busyGet.unsubscribe();
    this.busyGet = this.restClient
      .post("produit/generatePdf", request)
      .subscribe(
        (res: any) => {
          this.loading = false;
          console.log(res);
          if (!res["hasError"]) {
            const userAgent = navigator.userAgent.toLowerCase();
            const isTablet =
              /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
                userAgent
              );
            const isMobile = window.matchMedia(
              "only screen and (max-width: 760px)"
            ).matches;

            if (isTablet || isMobile) {
              // window.open('//'+res.item.file_url, '_blank').focus()
              window.open(res.item.file_url, "_blank").focus();
              this.modalRef.hide();

              return;
            } else {
              this.openPreviewModal(res.item.file_url);
            }
          } else {
            if (res["status"] && res["status"]["message"]) {
              this.utilities.showNotification(
                "snackbar-danger",
                this.utilities.formatMsgServeur(res["status"]["message"]),
                "top",
                "right"
              );
            }
          }
        },
        (err) => {
          console.log("Error occured", err);
          this.utilities.showNotification(
            "snackbar-danger",
            err || this.utilities.getMessageEndPointNotAvailble(),
            "top",
            "right"
          );
        }
      );
  }

  openPreviewModal(url) {
    // this.bsModalRefPreview = this.modalService.show(PreviewProduitComponent, {
    //   animated: true,
    //   keyboard: false,
    //   backdrop: "static",
    //   ignoreBackdropClick: true,
    //   class: "gray modal-lg modal-width-65 modal-custom",
    // });
    // this.bsModalRefPreview.content.currentLink = url;
  }

  // onAddItemToTable(){
  //   if(this.itemToAdd && !this.itemToAdd.age_max ){
  //     this.utilities.showNotification("snackbar-danger", "Veuillez renseigner age max",
  //     "top",
  //     "right");
  //     return
  //   }

  //   if(this.itemToAdd && !this.itemToAdd.prime ){
  //     this.utilities.showNotification("snackbar-danger", "Veuillez renseigner prime",
  //     "top",
  //     "right");
  //     return
  //   }

  //   if(this.itemToAdd && !this.itemToAdd.age_min )
  //     this.itemToAdd.age_min = 0
  //   if(this.itemToAdd && this.itemToAdd.statut_id)
  //     this.itemToAdd.statut_codification = this.itemsStatut.find(is=>is.id==this.itemToAdd.statut_id).codification
  //   this.itemsPrimeByProduit.push(this.itemToAdd)
  //   this.itemToAdd = { statut_id: this.itemToAdd.statut_id };
  // }

  onAddItemToTableTrancheAgeEtStatut() {
    // Validate if age_max is provided
    if (
      this.itemToAddStatutTrancheAge &&
      !this.itemToAddStatutTrancheAge.age_max
    ) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner age max",
        "top",
        "right"
      );
      return;
    }

    // Validate if prime is provided
    if (
      this.itemToAddStatutTrancheAge &&
      !this.itemToAddStatutTrancheAge.prime
    ) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner prime",
        "top",
        "right"
      );
      return;
    }

    // Set default age_min if not provided
    if (
      this.itemToAddStatutTrancheAge &&
      !this.itemToAddStatutTrancheAge.age_min
    ) {
      this.itemToAddStatutTrancheAge.age_min = 0;
    }

    // Validate that age_min is smaller than age_max
    if (
      this.itemToAddStatutTrancheAge.age_min >=
      this.itemToAddStatutTrancheAge.age_max
    ) {
      this.utilities.showNotification(
        "snackbar-danger",
        "L'âge minimum doit être inférieur à l'âge maximum",
        "top",
        "right"
      );
      return;
    }

    // Fetch statut_codification from itemsStatut
    if (
      this.itemToAddStatutTrancheAge &&
      this.itemToAddStatutTrancheAge.statut_id
    ) {
      this.itemToAddStatutTrancheAge.statut_codification =
        this.itemsStatut.find(
          (is) => is.id == this.itemToAddStatutTrancheAge.statut_id
        ).codification;
    }

    // Validate for overlaps within the same statut_codification
    const hasOverlap = this.itemsPrimeByStatutAndTrancheAge.some((item) => {
      return (
        item.statut_codification ===
          this.itemToAddStatutTrancheAge.statut_codification && // Match statut_codification
        this.itemToAddStatutTrancheAge.age_min <= item.age_max &&
        this.itemToAddStatutTrancheAge.age_max >= item.age_min
      );
    });

    if (hasOverlap) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Les plages d'âge se chevauchent pour ce statut. Veuillez corriger les valeurs.",
        "top",
        "right"
      );
      return;
    }

    // Add the item to the list if validation passes
    this.itemsPrimeByStatutAndTrancheAge.push(this.itemToAddStatutTrancheAge);

    // Reset itemToAddStatutTrancheAge but retain statut_id
    this.itemToAddStatutTrancheAge = {
      statut_id: this.itemToAddStatutTrancheAge.statut_id,
    };
  }
  onAddItemToTableTrancheAge() {
    // Validate if age_max is provided
    if (this.itemToAddTrancheAge && !this.itemToAddTrancheAge.age_max) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner age max",
        "top",
        "right"
      );
      return;
    }

    // Validate if prime is provided
    if (this.itemToAddTrancheAge && !this.itemToAddTrancheAge.prime) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner prime",
        "top",
        "right"
      );
      return;
    }

    // Set default age_min if not provided
    if (this.itemToAddTrancheAge && !this.itemToAddTrancheAge.age_min) {
      this.itemToAddTrancheAge.age_min = 0;
    }

    // Validate that age_min is smaller than age_max
    if (this.itemToAddTrancheAge.age_min >= this.itemToAddTrancheAge.age_max) {
      this.utilities.showNotification(
        "snackbar-danger",
        "L'âge minimum doit être inférieur à l'âge maximum",
        "top",
        "right"
      );
      return;
    }

    // Validate for overlaps within the same statut_codification
    const hasOverlap = this.itemsPrimeByTrancheAge.some((item) => {
      return (
        this.itemToAddTrancheAge.age_min <= item.age_max &&
        this.itemToAddTrancheAge.age_max >= item.age_min
      );
    });

    if (hasOverlap) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Les plages d'âge se chevauchent pour ce statut. Veuillez corriger les valeurs.",
        "top",
        "right"
      );
      return;
    }

    // Add the item to the list if validation passes
    this.itemsPrimeByTrancheAge.push(this.itemToAddTrancheAge);

    // Reset itemToAddTrancheAge
    let min = this.itemToAddTrancheAge.age_max + 1;
    let max =
      2 * this.itemToAddTrancheAge.age_max - this.itemToAddTrancheAge.age_min;
    this.itemToAddTrancheAge = { age_min: min, age_max: max };
  }

  getItemsPlafondConfigStatut() {
        if(!this.currentProduit.id || !this.currentProduit.mode_calcul_prime_id)
          return
        let request = {
          user_id: this.user.id,
          filiale_id: this.user.filiale_id,
          index: 0,
          size: 1000,
          data: {
            produit_id:this.currentProduit.id,
            mode_calcul_prime_id:this.currentProduit.mode_calcul_prime_id
            
          },
        };
    
        this.busyGet = this.restClient
          .post("primeProduit/getByCriteria", request)
          .subscribe(
            (res) => {
              if (res && res["items"]) {
                this.itemsPrimeByProduitId = _.orderBy(res["items"], ["libelle"], ["asc"]);
               
                this.itemsPrimeByProduitId.sort((a, b) => this.customSort(a, b));
                this.onInputChange({})
    
                this.setDefautValues();
              } else {
                this.itemsPrimeByProduitId = [];
              }
            },
            (err) => {
              this.itemsPrimeByProduitId = [];
            }
          );
      }
  getItemsProduitBaremeStatutConfig() {
        if(!this.currentProduit.id || !this.currentProduit.mode_calcul_prime_id)
          return
        let request = {
          user_id: this.user.id,
          filiale_id: this.user.filiale_id,
          index: 0,
          size: 1000,
          data: {
            produit_bareme_id:this.currentProduit.id,
            mode_calcul_prime_id:this.currentProduit.mode_calcul_prime_id,
            // bareme_id:this.currentBareme.id
            
          },
        };
    
        this.busyGet = this.restClient
          .post("primeProduitBareme/getByCriteria", request)
          .subscribe(
            (res) => {
              if (res && res["items"]) {
                this.itemsPrimeByProduitId = _.orderBy(res["items"], ["libelle"], ["asc"]);
               
                this.itemsPrimeByProduitId.sort((a, b) => this.customSort(a, b));
                this.onInputChange({})
    
                this.setDefautValues();

              } else {
                this.itemsPrimeByProduitId = [];
              }
            },
            (err) => {
              this.itemsPrimeByProduitId = [];
            }
          );
      }

  onChangeStatut() {}

  check_if_is_famille() {
    this.is_tarif_famille = false;
    if (this.itemsModeTarification && this.itemsModeTarification.length) {
      let match = this.itemsModeTarification.filter(
        (imf) =>
          imf.id == this.itemToSave.mode_tarification_id &&
          imf.codification == "FAMILLE"
      );
      this.is_tarif_famille = !!match.length;
    }
    let data = {
      mode_tarification_id:this.itemToSave.mode_tarification_id,
      is_tarif_famille:this.is_tarif_famille
    }
    this.onChangeModeTarification.emit(data)
  }

  set_default_mode_tarification(mode) {
    console.log("mode to select: ", mode);
    if (this.itemsModeTarification && this.itemsModeTarification.length) {
      this.itemToSave.mode_tarification_id = this.itemsModeTarification.filter(
        (imf) => imf.codification == mode
      )[0].id;
    }
  }

  getItemsStatut() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("statut/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsStatut = _.orderBy(res["items"], ["libelle"], ["asc"]);
            this.itemsStatutInitialized = [...this.itemsStatut];
            console.log(
              "itemsStatutInitialized: ",
              this.itemsStatutInitialized
            );
            this.itemsStatut.sort((a, b) => this.customSort(a, b));

            this.setDefautValues();
          } else {
            this.itemsStatut = [];
          }
        },
        (err) => {
          this.itemsStatut = [];
        }
      );
  }

  setDefautValues() {
    if (!this.currentProduit.id) {
      this.itemsStatutInitialized.map((isi) => {
        if (isi.codification == "A") {
          isi.age_min = this.findValueInGlobalParams("age_min_assure") || 18;
          isi.age_max = this.findValueInGlobalParams("age_max_assure") || 70;
          isi.nombre_autorise = 1;
          isi.nombre_supplementaire_autorise = 0;
          isi.surprime_si_supplementaire = 0;
        }
        if (isi.codification == "C") {
          isi.age_min = this.findValueInGlobalParams("age_min_conjoint") || 18;
          isi.age_max = this.findValueInGlobalParams("age_max_conjoint") || 70;
          isi.nombre_autorise = 1;
          isi.nombre_supplementaire_autorise = 0;
          isi.surprime_si_supplementaire = 0;
        }
        if (isi.codification == "E") {
          isi.age_min = this.findValueInGlobalParams("age_min_enfant") || 0;
          isi.age_max = this.findValueInGlobalParams("age_max_enfant") || 21;
          isi.nombre_autorise = 4;
          isi.nombre_supplementaire_autorise = 0;
          isi.surprime_si_supplementaire = 0;
        }
        if (isi.codification == "ASC") {
          isi.age_min = this.findValueInGlobalParams("age_min_ascendant") || 60;
          isi.age_max =
            this.findValueInGlobalParams("age_max_ascendant") || 100;
          isi.nombre_autorise = 0;
          isi.nombre_supplementaire_autorise = 0;
          isi.surprime_si_supplementaire = 0;
        }
        if (isi.codification == "AU") {
          isi.age_min = 0;
          isi.age_max = 23;
          isi.nombre_autorise = 0;
          isi.nombre_supplementaire_autorise = 0;
          isi.surprime_si_supplementaire = 0;
        }
      });
    } else {

      if (this.itemsPrimeByProduitId && this.itemsPrimeByProduitId.length) {
        this.itemsPrimeByProduitId.map((ip) => {
          ip.codification =
            this.itemsStatut &&
            this.itemsStatut.filter((ig) => ig.id == ip.statut_id)
              ? this.itemsStatut.filter((ig) => ig.id == ip.statut_id)[0]
                  .codification
              : "";
        });
        this.itemsStatutInitialized.map((isi) => {
          if (isi.codification == "A") {
            let item = this.itemsPrimeByProduitId.filter((ip) => ip.codification == "A")[0];
            isi.prime = item.prime;
            isi.plafond = item.plafond;
            isi.age_min = item.age_min;
            isi.age_max = item.age_max;
            isi.nombre_autorise = item.nombre_autorise;
            isi.nombre_supplementaire_autorise =
              item.nombre_supplementaire_autorise;
            isi.surprime_si_supplementaire = item.surprime_si_supplementaire;
          }
          if (isi.codification == "C") {
            let item = this.itemsPrimeByProduitId.filter((ip) => ip.codification == "C")[0];
            isi.prime = item.prime;
            isi.plafond = item.plafond;
            isi.age_min = item.age_min;
            isi.age_max = item.age_max;
            isi.nombre_autorise = item.nombre_autorise;
            isi.nombre_supplementaire_autorise =
              item.nombre_supplementaire_autorise;
            isi.surprime_si_supplementaire = item.surprime_si_supplementaire;
          }
          if (isi.codification == "E") {
            let item = this.itemsPrimeByProduitId.filter((ip) => ip.codification == "E")[0];
            isi.prime = item.prime;
            isi.plafond = item.plafond;
            isi.age_min = item.age_min;
            isi.age_max = item.age_max;
            isi.nombre_autorise = item.nombre_autorise;
            isi.nombre_supplementaire_autorise =
              item.nombre_supplementaire_autorise;
            isi.surprime_si_supplementaire = item.surprime_si_supplementaire;
          }
          if (isi.codification == "ASC") {
            let item = this.itemsPrimeByProduitId.filter((ip) => ip.codification == "ASC")[0];
            isi.prime = item.prime;
            isi.plafond = item.plafond;
            isi.age_min = item.age_min;
            isi.age_max = item.age_max;
            isi.nombre_autorise = item.nombre_autorise;
            isi.nombre_supplementaire_autorise =
              item.nombre_supplementaire_autorise;
            isi.surprime_si_supplementaire = item.surprime_si_supplementaire;
          }
          if (isi.codification == "AU") {
            let item = this.itemsPrimeByProduitId.filter((ip) => ip.codification == "AU")[0];
            isi.prime = item.prime;
            isi.plafond = item.plafond;
            isi.age_min = item.age_min;
            isi.age_max = item.age_max;
            isi.nombre_autorise = item.nombre_autorise;
            isi.nombre_supplementaire_autorise =
              item.nombre_supplementaire_autorise;
            isi.surprime_si_supplementaire = item.surprime_si_supplementaire;
          }
        });
      }

      
      console.log("itemsPrimeByProduitId: ", this.itemsPrimeByProduitId);
    }
    this.itemsStatutInitialized.sort((a, b) => this.customSort(a, b));
    this.get_nombre_par_famille();
    this.onInputChange({})

  }

  customSort(a, b) {
    const desiredOrder = ["ASSURE", "CONJOINT", "ENFANT", "ASCENDANT", "AUTRE"];
    return desiredOrder.indexOf(a.libelle) - desiredOrder.indexOf(b.libelle);
  }

  customSortTypeRembCodification(a, b) {
    const desiredOrder = ["TPRD", "TP", "RD", "TPG"];
    return (
      desiredOrder.indexOf(a.codification) -
      desiredOrder.indexOf(b.codification)
    );
  }

  openModalPrestataireReseau() {
    if (!this.itemToSave.reseau_de_soin_id) return;
    let modal: any;
    modal = ModalViewreseauDeSoinDetailComponent;
    this.modalRef = this.modalService.show(modal, {
      id: 5458545,
      class: "modal-width-75",
      ignoreBackdropClick: true,
      // data:boulangerie
    });
    let reseau_id = this.itemToSave.reseau_de_soin_id;
    let reseau_de_soin_libelle = this.itemsReseauDeSoin.filter(
      (ird) => ird.id == reseau_id
    )[0].libelle;
    let data = {
      reseau_de_soin_id: reseau_id,
      reseau_de_soin_libelle: reseau_de_soin_libelle,
    };
    if (data) this.modalRef.content.currentData = data;
    this.modalRef.onHide.subscribe((res) => {});
  }

  on_change_garant() {
    if (this.itemsGarant && this.itemsGarant.length) {
      let current_garant = {
        ...this.itemsGarant.filter(
          (ig) => ig.id == this.itemToSave.garant_id
        )[0],
      };
      console.log("current_garant: ", current_garant);
      if (!this.itemToSave.id) {
        this.itemToSave.taux_commission_sinistre =
          current_garant.taux_commission_sinistre;
        this.itemToSave.forfait_commission_sinistre =
          current_garant.forfait_commission_sinistre;
        this.itemToSave.taux_commission_prime =
          current_garant.taux_commission_prime;
        this.itemToSave.forfait_commission_prime =
          current_garant.forfait_commission_prime;
        this.itemToSave.type_remboursement_id =
          current_garant.type_remboursement_id;
        this.itemToSave.seuil_alerte_conso = current_garant.seuil_alerte_conso;
        this.itemToSave.seuil_suspension_tiers_payant =
          current_garant.seuil_suspension_tiers_payant;
        this.itemToSave.assure_remboursement =
          current_garant.assure_remboursement;
        this.itemToSave.mode_tarification_id =
          current_garant.mode_tarification_id;
        this.itemToSave.mode_reconduction_id =
          current_garant.mode_reconduction_id;
        this.itemToSave.mode_fractionnement_id =
          current_garant.mode_fractionnement_id;
        this.itemToSave.reseau_de_soin_id = current_garant.reseau_de_soin_id;
      }
    }
    this.check_if_is_famille();
  }

  

  get_nombre_par_famille() {
    let count: number = 0;
    this.itemsStatutInitialized.map((isi) => {
      const nombre = Number(isi.nombre_autorise) || 0; // If undefined, set to 0
      console.log(
        "isi.nombre_autorise: ",
        isi.nombre_autorise,
        "Converted:",
        nombre
      );
      count += nombre;
    });

    console.log("count: ", count);
    this.itemToSave.nombre_personnes_famille = count;
    console.log(
      "itemToSave.nombre_personnes_famille: ",
      this.itemToSave.nombre_personnes_famille
    );
  }

  get_plafond_par_famille() {
    // this.itemToSave.plafond_annuel_famille=0
    // this.itemsStatutInitialized.map(isi=>{
    //   if(isi.nombre_autorise>0 && isi.plafond>0){
    //     this.itemToSave.plafond_annuel_famille += Number(isi.plafond) || 0
    //   }
    // })
  }
  onChangeModeCalculPrime() {
    this.currentModeCalculPrime = this.itemsModeCalculPrime.find(
      (imcp) => imcp.id == this.itemToSave.mode_calcul_prime_id
    ).codification;
    console.log("currentModeCalculPrime: ", this.currentModeCalculPrime);
  }
  get_prime_par_famille() {
    this.itemToSave.prime_par_famille = 0;
    this.itemsStatutInitialized.map((isi) => {
      if (isi.nombre_autorise > 0 && isi.prime > 0) {
        this.itemToSave.prime_par_famille += Number(isi.prime);
      }
    });
  }

  // addItemToList(){
  //   if(!this.itemToAdd.id){
  //     this.utilities.showNotification(
  //       "snackbar-danger",
  //       "Veuillez renseigner garantie svp !",
  //       "bottom",
  //       "center"
  //     );
  //     return
  //   }

  //   let isExist = false
  //   if(this.items && this.items.length){
  //     isExist = !!this.items.filter(it=>it.garantie_id == this.itemToAdd.id).length
  //   }

  //   if(!isExist){
  //     this.itemToAdd.garantie_id = this.itemToAdd.id
  //     this.items.push(this.itemToAdd)
  //     this.itemToAdd = {}
  //   }
  //   else{
  //     this.utilities.showNotification(
  //       "snackbar-danger",
  //       "Cette garantie existe deja dans la liste !",
  //       "bottom",
  //       "center"
  //     );
  //   }
  // }

  

  setDefautValuesGarantie() {
    if (this.items && this.items.length) {
      this.items.map((it) => {
        if (
          this.defaultValues.type_remboursement_id &&
          !it.type_remboursement_id
        )
          it.type_remboursement_id = this.defaultValues.type_remboursement_id;
        if (this.defaultValues.plafond_police && !it.plafond_police)
          it.plafond_police = this.defaultValues.plafond_police;
        if (this.defaultValues.plafond_college && !it.plafond_college)
          it.plafond_college = this.defaultValues.plafond_college;
        if (this.defaultValues.plafond_famille && !it.plafond_famille)
          it.plafond_famille = this.defaultValues.plafond_famille;
        if (this.defaultValues.plafond_individuel && !it.plafond_individuel)
          it.plafond_individuel = this.defaultValues.plafond_individuel;
      });
    }
  }

  onSelectRow(item, event) {
    if (event.target.checked) {
      // this.itemsChecked = this.items.filter(it=>it.is_checked)
      this.itemsChecked.push({ ...item });
    } else {
      this.itemsChecked = this.itemsChecked.filter((it) => it.id !== item.id);
    }
    console.log("itemsChecked: ", this.itemsChecked);
  }

  onSelectAllRow(event) {
    if (this.items && this.items.length) {
      const isChecked = event.target.checked;

      // Update each item's is_checked property
      this.items.forEach((item) => (item.is_checked = isChecked));

      if (isChecked) {
        // Add all items to itemsChecked, avoiding duplicates
        this.items.forEach((item) => {
          if (
            !this.itemsChecked.some((checkedItem) => checkedItem.id === item.id)
          ) {
            this.itemsChecked.push(item);
          }
        });
      } else {
        // Remove all items from itemsChecked
        const uncheckedIds = this.items.map((item) => item.id);
        this.itemsChecked = this.itemsChecked.filter(
          (checkedItem) => !uncheckedIds.includes(checkedItem.id)
        );
      }
    }
  }


  openModalDetailGarant() {
    if (!this.itemToSave.garant_id) {
      return;
    }
    let modal: any;
    modal = ModalViewGarantDetailsComponent;
    this.modalRef = this.modalService.show(modal, {
      id: 545854015,
      class: "modal-width-75",
      ignoreBackdropClick: true,
      // data:boulangerie
    });
    let data = { id: this.itemToSave.garant_id };
    if (data) this.modalRef.content.currentData = data;
    this.modalRef.onHide.subscribe((res) => {});
  }
  onInputChange(event) {
    const reduce = this.itemsStatutInitialized.map(isi => ({
      statut_id: isi.id,
      garant_id: isi.garant_id,
      prime: isi.prime,
      plafond: isi.plafond,
      surprime_si_supplementaire: isi.surprime_si_supplementaire,
      nombre_supplementaire_autorise: isi.nombre_supplementaire_autorise,
      nombre_autorise: isi.nombre_autorise,
      age_min: isi.age_min,
      age_max: isi.age_max,
      codification: this.generateUniqueString(),
      code: this.generateUniqueString(),
    }));
  
    this.onChangePrimeStatutForm.emit(reduce);
  }
  

  ngOnInit() {
    this.getItemsModeTarification();
    this.getItemsGarant();
    this.getItemsStatut();
    this.getItemsParametreSysteme()
  }

}
